import { withStyles } from '@material-ui/core';
import SmartLockWidget from './SmartLockWidget';
import styles from './styles';

export default withStyles(styles)(SmartLockWidget)